var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainUserAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6203 19.9998C38.6203 15.0267 36.6831 10.3493 33.1659 6.83356C29.6502 3.31631 24.9728 1.37915 19.9996 1.37915C15.0264 1.37915 10.349 3.31631 6.83331 6.83356C3.31607 10.3493 1.37891 15.0267 1.37891 19.9998C1.37891 24.973 3.31607 29.6504 6.83331 33.1661C10.349 36.6834 15.0264 38.6205 19.9996 38.6205C24.9728 38.6205 29.6502 36.6834 33.1659 33.1661C36.6831 29.6504 38.6203 24.973 38.6203 19.9998Z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 19.6948C16.6405 19.6948 14.1455 17.1998 14.1455 14.1332C14.1455 11.0665 16.6405 8.573 19.7072 8.573C22.7739 8.573 25.2673 11.068 25.2673 14.1332C25.2673 17.2014 22.7723 19.6948 19.7072 19.6948ZM19.7072 9.95231C17.4022 9.95231 15.5248 11.8282 15.5248 14.1332C15.5248 16.4381 17.4007 18.3155 19.7072 18.3155C22.0137 18.3155 23.888 16.4397 23.888 14.1332C23.888 11.8266 22.0122 9.95231 19.7072 9.95231Z",
    fill: "#001130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4301 29.1278C31.4301 25.1722 28.2117 21.9539 24.2561 21.9539H15.7443C11.7887 21.9539 8.57031 25.1722 8.57031 29.1278V34.7033C9.00556 35.0435 9.4546 35.3623 9.91591 35.6596H9.94962V29.1278C9.94962 25.9324 12.5489 23.3332 15.7443 23.3332H24.2561C27.4515 23.3332 30.0508 25.9324 30.0508 29.1278V35.6596H30.0845C30.5458 35.3623 30.9948 35.0435 31.4301 34.7033V29.1278Z",
    fill: "#001130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainUserAvatarIcon);
export default __webpack_public_path__ + "static/media/MainUserAvatarIcon.50ed4d10abc91b58db396183b1dce01e.svg";
export { ForwardRef as ReactComponent };